import { render, staticRenderFns } from "./FormOptik.vue?vue&type=template&id=2a5a6b16&"
import script from "./FormOptik.vue?vue&type=script&lang=js&"
export * from "./FormOptik.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports